import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=65f0cbd5&scoped=true&"
import script from "./Notifications.vue?vue&type=script&lang=js&"
export * from "./Notifications.vue?vue&type=script&lang=js&"
import style0 from "./Notifications.scss?vue&type=style&index=0&id=65f0cbd5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f0cbd5",
  null
  
)

export default component.exports